// delReports/state.js

import { delFormInitialState } from "../../forms/delForm/delFormState";

export const activeDelReportingInitialState = {
  tabName: "reporting",
  isLoading: false,
  error: null,
  delMode: null,
  currentDel: null,
  delErrors: null,
  delActiveTab: "projects",
  delShowAll: false,
  delForm: delFormInitialState,
};
